"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lib_1 = require("@brandfree-front/lib");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const TagManager = __importStar(require("react-gtm-module"));
const AppHeader_1 = __importDefault(require("./components/AppHeader"));
const GDPRChoiceDetail_1 = __importDefault(require("./components/gdpr/GDPRChoiceDetail"));
const GDPRChoices_1 = __importDefault(require("./components/gdpr/GDPRChoices"));
const GDPRChoicesB2BMarketing_1 = __importDefault(require("./components/gdpr/GDPRChoicesB2BMarketing"));
const GDPRSignOnScreen_1 = __importDefault(require("./components/gdpr/GDPRSignOnScreen"));
const GDPRSuccess_1 = __importDefault(require("./components/gdpr/GDPRSuccess"));
const Landing_1 = __importDefault(require("./components/Landing"));
const PrivacyChoicesAndRights_1 = __importDefault(require("./components/privacynotice/PrivacyChoicesAndRights"));
const PublicPrivacyNoticeWrapper_1 = require("./components/privacynotice/PublicPrivacyNoticeWrapper");
const ConsentStore_1 = require("./stores/ConsentStore");
const RootStore_1 = __importStar(require("./stores/RootStore"));
const ParamsUtil_1 = require("./util/ParamsUtil");
const ApiUtil_1 = require("./util/ApiUtil");
const crm_components_1 = require("crm-components");
const config_1 = __importDefault(require("./config"));
const DataHandling_1 = __importDefault(require("./components/DataHandling"));
const OnlineHelp_1 = __importStar(require("./components/OnlineHelp"));
const ContactForm_1 = __importStar(require("./components/contactform/ContactForm"));
const ShowRequests_1 = __importDefault(require("./components/ShowRequests"));
const NotFound_1 = __importDefault(require("./components/NotFound"));
const RepresentationNotice_1 = __importDefault(require("./components/notices/RepresentationNotice"));
const CustomerMandateNotice_1 = __importDefault(require("./components/notices/CustomerMandateNotice"));
const EmailConfirmation_1 = __importDefault(require("./components/contactinfo/EmailConfirmation"));
const SsoStore_1 = require("./stores/SsoStore");
TagManager.initialize({ gtmId: 'GTM-5G2M3L' });
const hideHeader = (0, ParamsUtil_1.hasURLParam)('hideHeader', 'true');
let App = class App extends react_1.default.Component {
    constructor(initialStateHolder) {
        super(initialStateHolder);
        Object.defineProperty(this, "cookiebotEnabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "showRepresentativeNotice", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "showCustomerMandateNotice", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this);
        const rootStore = new RootStore_1.default();
        rootStore.init();
        rootStore.locationStore.redirectUrl = new URLSearchParams(window.location.search).get('goToUrl');
        this.rootStore = rootStore;
        (0, ApiUtil_1.initializeAxiosInterceptors)(rootStore.ssoStore);
    }
    componentDidMount() {
        window.addEventListener('CookiebotOnLoad', () => {
            this.isCookiebotEnabled();
        });
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g;
        const { translateStore: { translate, globalTranslations }, ssoStore } = this.rootStore;
        if ((0, SsoStore_1.shouldLoadSSO)(window.location.pathname) && !!!this.props.appNotLoaded && !this.rootStore.ssoStore.loaded) {
            return null;
        }
        if (!globalTranslations) {
            return null;
        }
        const icons = require('@telia-front/icon/lib/svg/icons.svg');
        const themeProvider = require('@core-front/theme-provider');
        return (react_1.default.createElement(crm_components_1.ApplicationWrapper, { environment: config_1.default.componentTier, frontLibrary: { ...require('@brandfree-front/lib'), ...themeProvider }, brand: "TELIA", icons: icons, disableSso: !(0, SsoStore_1.shouldLoadSSO)(window.location.pathname), sso: {
                isDealer: ssoStore.isDealer,
                isLoggedIn: ssoStore.isLoggedIn,
                isLoggedInWithHardAuth: ssoStore.isLoggedInWithHardAuth,
                loggedInPerson: {
                    registrationNumber: (_b = (_a = ssoStore.auth) === null || _a === void 0 ? void 0 : _a.person) === null || _b === void 0 ? void 0 : _b.personalCode,
                    registrationNumberCountryCode: (_d = (_c = ssoStore.auth) === null || _c === void 0 ? void 0 : _c.person) === null || _d === void 0 ? void 0 : _d.personalCodeCountryCode
                },
                representative: { ...ssoStore.customer, type: (_e = ssoStore.customer) === null || _e === void 0 ? void 0 : _e.type }
            } },
            react_1.default.createElement(RootStore_1.RootStoreContext.Provider, { value: this.rootStore },
                react_1.default.createElement(lib_1.Main, { background: this.rootStore.publicPrivacyNoticeStore.isPublicPrivacyNoticeOpen ? 'primary-3' : 'primary-4', consentEnabled: this.cookiebotEnabled, consent: window.Cookiebot ? { ...window.Cookiebot.consent } : { necessary: true } },
                    !hideHeader && (react_1.default.createElement(lib_1.MainHeader, null,
                        react_1.default.createElement(AppHeader_1.default, null))),
                    react_1.default.createElement(lib_1.MainContent, null,
                        react_1.default.createElement(lib_1.Container, null,
                            react_1.default.createElement(crm_components_1.Routes, { restrictions: { requiresRepresentative: true }, onChange: (route, errors) => this.onLocationChange(route, errors) },
                                react_1.default.createElement(crm_components_1.Route, { path: "/", element: react_1.default.createElement(Landing_1.default, null), restrictions: null }),
                                react_1.default.createElement(crm_components_1.Route, { path: "/gdpr", element: react_1.default.createElement(GDPRChoices_1.default, null), restrictions: {
                                        requiresHardAuth: true,
                                        requiresRepresentingSelf: ((_f = ssoStore.customer) === null || _f === void 0 ? void 0 : _f.type) === 'B2C',
                                        receivedMandates: ((_g = ssoStore.customer) === null || _g === void 0 ? void 0 : _g.type) === 'B2B' ? { requiresMandates: ['LEGAL'] } : undefined
                                    }, fallbackElement: this.showRepresentativeNotice ? react_1.default.createElement(RepresentationNotice_1.default, null) : this.showCustomerMandateNotice ? react_1.default.createElement(CustomerMandateNotice_1.default, null) : undefined }),
                                react_1.default.createElement(crm_components_1.Route, { path: "/gdpr-marketing", element: react_1.default.createElement(GDPRChoicesB2BMarketing_1.default, null), restrictions: { requiresHardAuth: true, customerType: 'B2B', receivedMandates: { requiresMandates: ['LEGAL'] } }, fallbackElement: react_1.default.createElement(CustomerMandateNotice_1.default, null) }),
                                react_1.default.createElement(crm_components_1.Route, { path: "/sign-on-screen", element: react_1.default.createElement(GDPRSignOnScreen_1.default, null), restrictions: { requiresDealer: true } }),
                                react_1.default.createElement(crm_components_1.Route, { path: "/success", element: react_1.default.createElement(GDPRSuccess_1.default, null) }),
                                react_1.default.createElement(crm_components_1.Route, { path: "/personaalsed-pakkumised-info", element: react_1.default.createElement(GDPRChoiceDetail_1.default, { type: ConsentStore_1.ConsentType.TRAFFIC_DATA_ANALYSIS }) }),
                                react_1.default.createElement(crm_components_1.Route, { path: "/asukoha-andmete-info", element: react_1.default.createElement(GDPRChoiceDetail_1.default, { type: ConsentStore_1.ConsentType.LOCATION_DATA_ANALYSIS }) }),
                                react_1.default.createElement(crm_components_1.Route, { path: "/turunduspakkumised-info", element: react_1.default.createElement(GDPRChoiceDetail_1.default, { type: ConsentStore_1.ConsentType.DIRECT_MARKETING }) }),
                                react_1.default.createElement(crm_components_1.Route, { path: "/andmete-tootlus", element: react_1.default.createElement(DataHandling_1.default, null) }),
                                react_1.default.createElement(crm_components_1.Route, { path: "/privaatsusteade", element: react_1.default.createElement(PublicPrivacyNoticeWrapper_1.PublicPrivacyNoticeWrapper, null), restrictions: null }),
                                react_1.default.createElement(crm_components_1.Route, { path: "/privaatsusvalikud-ja-oigused", element: react_1.default.createElement(PrivacyChoicesAndRights_1.default, { publicPrivacyNoticeStore: this.rootStore.publicPrivacyNoticeStore }), restrictions: null }),
                                react_1.default.createElement(crm_components_1.Route, { path: "/parandan-andmeid", element: react_1.default.createElement(OnlineHelp_1.default, { documentId: OnlineHelp_1.OnlineHelpDocumentId.CORRECT_PERSONAL_DATA }), restrictions: null }),
                                react_1.default.createElement(crm_components_1.Route, { path: "/unustamine", element: react_1.default.createElement(ContactForm_1.default, { contactFormType: ContactForm_1.ContactFormType.FORGOTTEN, redirectUrlAfterSubmit: "/" }), restrictions: null }),
                                react_1.default.createElement(crm_components_1.Route, { path: "/esitan-vastuvaite", element: react_1.default.createElement(OnlineHelp_1.default, { documentId: OnlineHelp_1.OnlineHelpDocumentId.OBJECTION }), restrictions: null }),
                                react_1.default.createElement(crm_components_1.Route, { path: "/piiran-tootlust", element: react_1.default.createElement(OnlineHelp_1.default, { documentId: OnlineHelp_1.OnlineHelpDocumentId.RESTRICT_DATA_PROCESSING }), restrictions: null }),
                                react_1.default.createElement(crm_components_1.Route, { path: "/kannan-andmeid", element: react_1.default.createElement(react_1.default.Fragment, null,
                                        react_1.default.createElement(ShowRequests_1.default, { requestType: "PORTABILITY" }),
                                        react_1.default.createElement(OnlineHelp_1.default, { documentId: OnlineHelp_1.OnlineHelpDocumentId.TRANSFER_PERSONAL_DATA })), restrictions: null }),
                                react_1.default.createElement(crm_components_1.Route, { path: "/tutvun-andmetega", element: react_1.default.createElement(react_1.default.Fragment, null,
                                        react_1.default.createElement(ShowRequests_1.default, { requestType: "ACCESS" }),
                                        react_1.default.createElement(OnlineHelp_1.default, { documentId: OnlineHelp_1.OnlineHelpDocumentId.VIEW_PERSONAL_DATA })), restrictions: null }),
                                react_1.default.createElement(crm_components_1.Route, { path: "/valideerimine/:uuid", element: react_1.default.createElement(EmailConfirmation_1.default, null), restrictions: null }),
                                react_1.default.createElement(crm_components_1.Route, { path: "*", element: react_1.default.createElement(NotFound_1.default, null), restrictions: null })))),
                    !window.location.pathname.includes('valideerimine') && !this.rootStore.publicPrivacyNoticeStore.isPublicPrivacyNoticeOpen && (react_1.default.createElement(lib_1.MainBackground, { imageLeft: {
                            srcset: '//res.cloudinary.com/telia/image/upload/w_280,fl_lossy,f_auto,q_auto:best/gdpr/gdpr-pebbles 280w, //res.cloudinary.com/telia/image/upload/w_560,fl_lossy,f_auto,q_auto:best/gdpr/gdpr-pebbles 560w,',
                            width: 280,
                            role: 'presentation'
                        }, imageRight: {
                            srcset: '//res.cloudinary.com/telia/image/upload/w_332,fl_lossy,f_auto,q_auto:best/gdpr/gdpr-brands 332w, //res.cloudinary.com/telia/image/upload/w_664,fl_lossy,f_auto,q_auto:best/gdpr/gdpr-brands 664w,',
                            width: 332,
                            role: 'presentation'
                        }, imageBottom: {
                            srcset: '//res.cloudinary.com/telia/image/upload/w_247,fl_lossy,f_auto,q_auto:best/gdpr/gdpr-pre-footer 247w, //res.cloudinary.com/telia/image/upload/w_494,fl_lossy,f_auto,q_auto:best/gdpr/gdpr-pre-footer 494w',
                            width: 247,
                            role: 'presentation'
                        }, pullBottom: true })),
                    react_1.default.createElement(lib_1.MainFooter, null, !this.rootStore.publicPrivacyNoticeStore.isPublicPrivacyNoticeOpen && (react_1.default.createElement(lib_1.Footer, null,
                        translate('landing.footerInfo'),
                        "\u00A0",
                        react_1.default.createElement(lib_1.Anchor, { url: "/privaatsusteade" }, translate('landing.footerInfoLink')))))))));
    }
    onLocationChange(route, errors) {
        this.rootStore.locationStore.setCurrentLocation(route);
        this.showRepresentativeNotice = false;
        this.showCustomerMandateNotice = false;
        if (errors.find((error) => error.type === crm_components_1.RouteErrorType.AUTH_LEVEL)) {
            const { ssoStore } = this.rootStore;
            if (ssoStore.isLoggedIn && !ssoStore.isLoggedInWithHardAuth) {
                ssoStore.doLogout();
                (0, crm_components_1.navigate)('/');
                return;
            }
            ssoStore.openSsoIframe();
            return;
        }
        if (errors.find((error) => error.type === crm_components_1.RouteErrorType.CUSTOMER_TYPE)) {
            (0, crm_components_1.navigate)('/gdpr');
        }
        if (errors.find((error) => error.type === crm_components_1.RouteErrorType.REPRESENTATIVE)) {
            this.showRepresentativeNotice = true;
        }
        if (errors.find((error) => error.type === crm_components_1.RouteErrorType.MANDATE)) {
            this.showCustomerMandateNotice = true;
        }
    }
    isCookiebotEnabled() {
        const cookieControlDialog = window.CookieControl ? !!window.CookieControl.Dialog : false;
        const cookiebotConsented = window.Cookiebot ? window.Cookiebot.consented || !window.Cookiebot.declined : false;
        const isCookiebotLoaded = cookieControlDialog || cookiebotConsented;
        const isCookiebotBlocked = !!window.Cookiebot && !window.CookieControl;
        this.cookiebotEnabled = isCookiebotLoaded || isCookiebotBlocked;
    }
};
__decorate([
    mobx_1.observable
], App.prototype, "cookiebotEnabled", void 0);
__decorate([
    mobx_1.observable
], App.prototype, "showRepresentativeNotice", void 0);
__decorate([
    mobx_1.observable
], App.prototype, "showCustomerMandateNotice", void 0);
__decorate([
    mobx_1.action
], App.prototype, "onLocationChange", null);
__decorate([
    mobx_1.action
], App.prototype, "isCookiebotEnabled", null);
App = __decorate([
    mobx_react_1.observer
], App);
exports.default = App;
